import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import $ from 'jquery'

import DestinationActions from '../../Redux/DestinationRedux'

import FormCreate from '../../Containers/Destination/FormCreate'
import FormDelete from '../../Containers/Destination/FormDelete'
import FormEdit from '../../Containers/Destination/FormEdit'

class DestinationPage extends React.Component {
  constructor (props) {
    super (props)

    this.state = {
      showModal: null,
      selected: null,
      filter: {
        name: ''
      },
      reverse: false
    }
  }

  _filterChange = (event, field) => {
    let newState = {...this.state.filter}
    const val = event.target.value
    newState[field] = val
    this.setState({ filter: newState })
    
    if (field === 'name') {
      $.expr[':'].contains = function(a, i, m) {
        return $(a).text().toUpperCase()
            .indexOf(m[3].toUpperCase()) >= 0;
      }
      if (val) {
        $('td[data-filter="name"]:not(:contains("'+ val +'"))').parent().hide()
        $('td[data-filter="name"]:contains("'+ val +'")').parent().show()
      } else {
        $("tr:hidden").show()
      }
    }
  }

  _toggleModal = (modalId = null) => {
    this.setState({showModal: modalId})
  }

  _select = (obj, action) => {
    this.setState({ selected: obj })
    this._toggleModal(action)
  }

  componentDidMount = () => {
    this.props.getDestination()
  }

  _reverseOrder = () => {
    this.setState({
      reverse: !this.state.reverse
    })

    $("tbody").each(function(elem,index){
      var arr = $.makeArray($("tr",this).detach());
      arr.reverse();
        $(this).append(arr);
    })
  }

  render() {
    const { data, fetching, err} = this.props

    return (
      <div>
        <header className="section">
          <div className="title-block d-flex mb-3">
            <h3 className="title mr-auto">
              Destination List
              {fetching && 
                <div className="badge badge-info ml-2">Loading ...</div> 
              }
            </h3>
            <button className="btn btn-primary ml-auto" onClick={() => this._toggleModal('create')}>Create Destination</button>
          </div>
          <div className="title-block">
            <p className="title-description">Filter:</p>
            <div className="form-inline">
              <div className="form-group">
                <label htmlFor="name" className="control-label mr-2">Name</label>
                <input type="text" className="form-control" placeholder="Destination Name" value={this.state.filter.name} onChange={(event) => this._filterChange(event, 'name')}/>
              </div>
            </div>
          </div>
        </header>

        <section className="section">

          {err &&
            <div className="alert alert-danger">{err}</div> 
          }
          <div className="card" style={{ minWidth: '100%' }}>
            <div className="card-block">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Narrow Image</th>
                    <th>Wide Image</th>
                    <th>Wide Mobile Image</th>
                    <th role="button" onClick={() => this._reverseOrder()}>Priority <span className="badge badge-info"><i className={`fas fa-${this.state.reverse ? 'sort-numeric-down' : 'sort-numeric-up'}`}></i></span></th>
                    <th>Experience Count</th>
                    <th>Edit Content</th>
                    <th>Update Image</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {!data ?
                      <tr>
                        <td colSpan="9" className="text-center">- No Data -</td>
                      </tr>
                    :
                    data.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td data-filter="name">{item.name || '-'}</td>
                          <td>
                            <img src={item.image_url ? item.image_url.narrow : ''} alt="" style={{height: '75px'}}/>
                          </td>
                          <td>
                            <img src={item.image_url ? item.image_url.wide : ''} alt="" style={{height: '75px'}}/>
                          </td>
                          <td>
                            <img src={item.image_url ? item.image_url.wide_mobile : ''} alt="" style={{height: '75px'}}/>
                          </td>
                          <td>{item.priority || '-'}</td>
                          <td>{item.experience_count || 0}</td>
                          <td>
                            <button onClick={() => this._select(item, 'edit-content')} className="btn btn-primary">
                              <i className="fas fa-edit"></i>
                            </button>
                          </td>
                          <td>
                            <button onClick={() => this._select(item, 'edit-image')} className="btn btn-primary">
                              <i className="fa fa-image"></i>
                            </button>
                          </td>
                          <td>
                            <button onClick={() => this._select(item, 'delete')} className="btn btn-danger">
                              <i className="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* MODAL */}
        {/* CREATE DESTINATION */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create'} onClose={this._toggleModal} closeOnOverlayClick>
          <FormCreate closeModal={() => this._toggleModal()}/>
        </Modal>

        {/* DELETE DESTINATION */}
        <Modal open={this.state.showModal === 'delete'} onClose={this._toggleModal} closeOnOverlayClick>
          <FormDelete data={this.state.selected} closeModal={() => this._toggleModal()}/>
        </Modal>

        {/* EDIT DESTINATION */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-content' || this.state.showModal === 'edit-image'} onClose={this._toggleModal} closeOnOverlayClick>
          <FormEdit data={this.state.selected} editType={this.state.showModal} closeModal={() => this._toggleModal()}/>
        </Modal>

      </div>
    )
  }
}

const stateToProps = (state) => ({
  ...state.destination
})

const dispatchToProps = (dispatch) => ({
  getDestination: () => dispatch(DestinationActions.destinationRequest())
})

export default connect(stateToProps, dispatchToProps)(DestinationPage)



// WEBPACK FOOTER //
// ./src/Pages/Destination/ManageDestination.js